import React, { useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { FaInfo } from 'react-icons/fa';

import api from '../../../../services/api';

import TableRowProdutoSimples from './TableRowProdutoSimples';
import SummaryGrupoSimples from './SummaryGrupoSimples';

import { InfoHeaderButton } from '../styles';
import styles from '../styles/material_styles';

import { SimpleProductProvider } from '../../../../hooks/newSimpleProduct';
import { EditProdutoProvider } from '../../../../hooks/editProduto';
import { useRegisterAdded } from '../../../../hooks/registerAdded';
import { useAuth } from '../../../../hooks/auth';

interface AccordionProps {
  grupo_id: number;
  descricao: string;
  pausar_venda: boolean;
  tipo_produto: number;
  imagem: string;
}

interface ProductsProps {
  id: number;
  descricao: string;
  estoque_atual: number;
  preco: number;
  pausar_venda: boolean;
  grupo_produto_id: number;
  unidade_medida_id: number;
  imagem: string;
  codigo: string;
  ordem: number;
}

const AcordeaoSimples: React.FC<AccordionProps> = ({
  grupo_id,
  descricao,
  pausar_venda,
  tipo_produto,
  imagem,
}) => {
  const [products, setProducts] = useState<ProductsProps[]>();

  const classes = styles();
  const { user } = useAuth();
  const { hasProductUpdated, handleSetHasProductUpdated } = useRegisterAdded();

  useEffect(() => {
    async function loadProductsData(): Promise<void> {
      const grupo_produto_request = await api.get(
        `/grupo/grupo_produto/${grupo_id}`,
      );
      const prices = await api.get(`/produto/preco/${grupo_id}`);
      const estoque = await api.get(`/estoque/${user.empresa_id}`);

      const produtosFormatted: ProductsProps[] = [];

      grupo_produto_request.data.map(
        async (product_item: any): Promise<void> => {
          const { produto } = product_item;
          let productFormatted: ProductsProps = {} as ProductsProps;

          if (tipo_produto == 2) {
            productFormatted = {
              id: produto.id,
              descricao: produto.descricao,
              estoque_atual: 0,
              preco: produto.preco_custo,
              pausar_venda: !!produto.pausar_venda,
              grupo_produto_id: product_item.id,
              unidade_medida_id: produto.unidade_medida_id,
              imagem: produto.imagem,
              codigo: produto.codigo,
              ordem: produto.ordem,
            };
          } else {
            prices.data.map((price_item: any): void => {
              if (produto.id === price_item.produto_id) {
                productFormatted = {
                  id: produto.id,
                  descricao: produto.descricao,
                  estoque_atual: 0,
                  preco: price_item.valor,
                  pausar_venda: !!produto.pausar_venda,
                  grupo_produto_id: product_item.id,
                  unidade_medida_id: produto.unidade_medida_id,
                  imagem: produto.imagem,
                  codigo: produto.codigo,
                  ordem: produto.ordem,
                };
              }
            });
          }

          estoque.data.map((estoque_item: any): void => {
            const { produto_id, estoque_atual } = estoque_item;
            if (produto.id === produto_id) {
              if (Math.trunc(estoque_atual) - estoque_atual == 0) {
                productFormatted.estoque_atual = Math.trunc(estoque_atual);
                return;
              }

              productFormatted.estoque_atual = estoque_atual;
            }
          });

          produtosFormatted.push(productFormatted);
        },
      );

      setProducts([...produtosFormatted]);
    }

    if (hasProductUpdated) {
      loadProductsData();
      handleSetHasProductUpdated(false);
      return;
    }

    loadProductsData();
  }, [
    grupo_id,
    tipo_produto,
    user.empresa_id,
    hasProductUpdated,
    handleSetHasProductUpdated,
  ]);

  return (
    <SimpleProductProvider>
      <div className={classes.root}>
        <Accordion expanded>
          <SummaryGrupoSimples
            grupo_id={grupo_id}
            descricao={descricao}
            pausar_venda={pausar_venda}
            tipo_produto={tipo_produto}
            imagem={imagem}
          />

          <AccordionDetails>
            <Grid container>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12} className={classes.tableWrapper}>
                    <TableContainer component={Paper}>
                      <Table
                        className={classes.table}
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Item</TableCell>

                            <TableCell align="center">Código PDV</TableCell>

                            <TableCell align="center">Estoque</TableCell>

                            <TableCell align="center">
                              {tipo_produto !== 2 ? 'Preço' : 'Preço Custo'}
                              <InfoHeaderButton type="button">
                                <FaInfo size={8} />
                              </InfoHeaderButton>
                            </TableCell>

                            <TableCell align="center">
                              Status de Venda
                            </TableCell>

                            <TableCell />
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {products
                            ?.sort((a, b) => a.ordem - b.ordem)
                            .map((item) => (
                              <EditProdutoProvider key={item.id}>
                                <TableRowProdutoSimples
                                  key={item.id}
                                  tipo_produto={tipo_produto}
                                  grupo_produto_id={item.grupo_produto_id}
                                  produto_id={item.id}
                                  descricao={item.descricao}
                                  estoque_atual={item.estoque_atual}
                                  preco={item.preco}
                                  pausar_venda={item.pausar_venda}
                                  grupo_id={grupo_id}
                                  grupo_descricao={descricao}
                                  unidade_medida_id={item.unidade_medida_id}
                                  imagem={item.imagem}
                                  codigo={item.codigo}
                                />
                              </EditProdutoProvider>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </div>
    </SimpleProductProvider>
  );
};

export default AcordeaoSimples;
